import { render, staticRenderFns } from "./install_apps.vue?vue&type=template&id=071a0720"
import script from "./install_apps.vue?vue&type=script&lang=js"
export * from "./install_apps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports